import * as React from "react";
const EditIcon = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 13V15C22.5 20 20.5 22 15.5 22H9.5C4.5 22 2.5 20 2.5 15V13.48"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 2H9.5C4.5 2 2.5 4 2.5 9"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4318 9.01123L21.4818 7.96123C22.8418 6.60123 23.4818 5.02123 21.4818 3.02123C19.4818 1.02123 17.9018 1.66123 16.5418 3.02123L8.66183 10.9012C8.36183 11.2012 8.06183 11.7912 8.00183 12.2212L7.57183 15.2312C7.41183 16.3212 8.18183 17.0812 9.27183 16.9312L12.2818 16.5012C12.7018 16.4412 13.2918 16.1412 13.6018 15.8412L16.7818 12.6612L17.5118 11.9312"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4102 4.14844C16.0802 6.53844 17.9502 8.40844 20.3502 9.08844"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EditIcon;
